<template>
  <UserContentWrapper :title="t('change.bio')">
    <div class="n-user-set-bio">
      <AppBackButton
        :linkMode="true"
        link="/user/settings"
        class="n-user-set-bio__back"
      />

      <AppInput
        v-model="firstname"
        id="u-name"
        :label="t('name')"
        class="n-user-set-bio__input"
      />
      <AppInput
        v-model="lastname"
        id="u-lastname"
        :label="t('surname')"
        class="n-user-set-bio__input"
      />

      <AppInput
        v-model="secname"
        id="u-secname"
        :label="t('secname')"
        class="n-user-set-bio__input"
      />
      <Datepicker
        v-model="birthday"
        locale="ru"
        class="n-user-set-bio__input n-date-picker"
        autoApply
        inlineWithInput
        :enable-time-picker="false"
      />

      <AppSwitch
        @switch="notificationAgree = !notificationAgree"
        :chosed="notificationAgree"
        :okLabel="`${t('notification.accept')}`"
        :nokLabel="`${t('notification.notaccept')}`"
        class="n-user-set-bio__input"
      ></AppSwitch>

      

      <AppButton
        class="n-user-set-bio__save"
        @click="
          $emit('changeBio', { firstname: firstname, lastname: lastname, secname: secname, birthday: birthday, notificationAgree: notificationAgree})
        "
        :disabled="!firstname && !lastname"
        >{{ t("save") }}
      </AppButton>

     
               
             
    </div>
  </UserContentWrapper>
</template>

<script>
import AppInput from "@/elements/AppInput";
import AppButton from "@/elements/AppButton";
import UserContentWrapper from "@/elements/UserContentWrapper.vue";
import Datepicker from "@vuepic/vue-datepicker";

import { t } from "@/utils/translate";
import { ref, onMounted } from "vue";
import { customAxios } from "@/service/customAxios";

import AppBackButton from "@/elements/AppBackButton.vue";
import AppSwitch from "@/elements/AppSwitch.vue";

export default {
  emits: ["changeBio"],
  components: { AppButton, AppInput, UserContentWrapper, AppBackButton, AppSwitch, Datepicker},
  setup() {
    const firstname = ref("");
    const lastname = ref("");
    const secname = ref("");
    const userData = ref("");
    const notificationAgree = ref(false);
    const birthday = ref("");

    async function getUserData() {
      try {
        const r = await customAxios.get(`person/get_my_profile`);

        userData.value  = r.data;
        firstname.value = userData.value.firstname;
        lastname.value  = userData.value.lastname;
        secname.value  = userData.value.secname;
        notificationAgree.value = userData.value.notificationAgree;
        birthday.value = userData.value.birthday
      } catch (e) {
        console.log("e: " + e);
      }
    }

    onMounted(() => {
      getUserData();
    });

    return { t, firstname, lastname, secname, notificationAgree, birthday };
  },
};
</script>

<style lang="scss">
.n-user-set-bio {
  &__input + .n-user-set-bio__input {
    margin-top: 16px;
  }

  &__save {
    @include button-default;
    margin-top: 30px;
  }
}


.n-date-picker{
  .dp__input {
    line-height: 2.375rem; 
    border-radius: 8px;
  }

}
</style>
